module.exports = __webpack_public_path__ + "static/media/KH.09112d05.svg";